import React from 'react';
import { motion } from 'framer-motion';
export const Section = ({
  children,
  className = '',
  id = ''
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => <motion.section id={id} initial={{
  opacity: 0,
  y: 30
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.6
}} className={`py-12 md:py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full bg-transparent ${className}`} data-id="element-394">
    {children}
  </motion.section>;
export const CTAButton = ({
  children,
  href,
  className = '',
  fullWidth = false,
  variant = 'purple'
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'purple' | 'gold';
}) => {
  const bgClass = variant === 'purple' ? 'purple-gradient-bg' : 'gold-gradient-bg';
  const shadowClass = variant === 'purple' ? 'shadow-[0_0_20px_rgba(76,29,149,0.3)] hover:shadow-[0_0_30px_rgba(76,29,149,0.5)]' : 'shadow-[0_0_20px_rgba(201,169,97,0.3)] hover:shadow-[0_0_30px_rgba(201,169,97,0.5)]';
  const textClass = variant === 'gold' ? 'text-brand-violetDark' : 'text-white';
  const classes = `inline-flex items-center justify-center px-8 py-4 text-lg font-bold ${textClass} ${bgClass} rounded-full ${shadowClass} transition-shadow duration-300 cursor-pointer ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    return <motion.a href={href} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={classes} data-id="element-395">
        {children}
      </motion.a>;
  }
  return <motion.a href="#pricing" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={classes} data-id="element-396">
      {children}
    </motion.a>;
};